module.exports = __webpack_public_path__ + "373aa72398256cfbf9f66b27065072a2.png";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Spotin_TM_Logo_Sand_Big_RGB.png
// module id = 292
// module chunks = 0